/*-- npm packages --*/
import React from "react";

/*-- atoms --*/
import CustomLink from "../CustomLink/CustomLink.atom";

/*-- assets --*/
import Instagram from "../../../assets/svgs/Instagram.svg";
import Twitter from "../../../assets/svgs/Twitter.svg";
import Linkedin from "../../../assets/svgs/Linkedin.svg";
import Facebook from "../../../assets/svgs/Facebook.svg";
import Youtube from "../../../assets/svgs/Youtube.svg";
import classNames from "classnames";

export enum SocialLinkType {
  INSTAGRAM = "INSTAGRAM",
  TWITTER = "TWITTER",
  LINKEDIN = "LINKEDIN",
  FACEBOOK = "FACEBOOK",
  YOUTUBE = "YOUTUBE",
}

interface SocialLinkProps {
  type: SocialLinkType;
  url: string;
  size?: "sm" | "lg";
}

const SocialLink: React.FC<SocialLinkProps> = ({ type, url, size = "lg" }) => {
  const SVG_CLASSES: string = "text-Primary-900 group-hover:text-White group-hover:text-sherpa-blue-900 transition-all";
  const SECONDARY_SVG_FILL_CLASSES: string =
    "text-White group-hover:text-Primary-900 group-hover:text-sherpa-blue-150 transition-all";

  const getSocialIcon = (): React.ReactNode => {
    switch (type) {
      case SocialLinkType.INSTAGRAM:
        return <Instagram primaryFill={SVG_CLASSES} secondaryFill={SECONDARY_SVG_FILL_CLASSES} />;
      case SocialLinkType.TWITTER:
        return <Twitter className={SVG_CLASSES} />;
      case SocialLinkType.LINKEDIN:
        return <Linkedin className={SVG_CLASSES} />;
      case SocialLinkType.FACEBOOK:
        return <Facebook className={SVG_CLASSES} />;
      case SocialLinkType.YOUTUBE:
        return <Youtube primaryFill={SVG_CLASSES} secondaryFill={SECONDARY_SVG_FILL_CLASSES} />;
    }
  };

  return (
    <CustomLink
      className={classNames(
        ` rounded-full flex items-center justify-center group transition-all bg-White hover:bg-Primary-900 hover:!bg-sherpa-blue-150`,
        {
          "w-[50px] h-[50px] scale-[0.65]": size === "sm",
          "w-[64px] h-[64px]": size === "lg",
        },
      )}
      url={url}
      aria-label={`${type.toLowerCase()}-social-button`}
    >
      {getSocialIcon()}
    </CustomLink>
  );
};

export default SocialLink;
